import useCurrencyFormatter from '@/hooks/useCurrencyFormatter';
import usePointsFormatter from '@/hooks/usePointsFormatter';
import { useTranslation } from '@/i18n';
import { LoyaltyTierStatMetrics, LoyaltyTierStatMetricTypeCategory, LoyaltyTierStatMetricsType } from '@/models/loyaltyModels';
import { useAppSelector } from '@/redux/hooks';

import AmbaImage from '../global/AmbaImage';

export type TierItemProps = {
  image: string;
  color: string;
  description: string;
  earned?: boolean;
  extraClass?: string;
  name: string;
  points?: number;
};

const TierItem = ({ image, color, description, earned, extraClass, name, points = 0 }: TierItemProps) => {
  const { t } = useTranslation('dashboard');
  const formatCurrency = useCurrencyFormatter();
  const formatPoints = usePointsFormatter();

  const company = useAppSelector((state) => state.auth.companyAccount);
  const tier_stat_metric = company?.loyalty_tier_stat_metric ?? LoyaltyTierStatMetrics.POINTS;

  const metricType = LoyaltyTierStatMetricTypeCategory[tier_stat_metric];
  const value =
    points == undefined
      ? '-'
      : metricType === LoyaltyTierStatMetricsType.POINTS
        ? formatPoints(points)
        : metricType === LoyaltyTierStatMetricsType.MONETARY
          ? formatCurrency(points)
          : points.toLocaleString();

  return (
    <div
      className={`badgeContainer d-flex overflow-hidden ${extraClass}`}
      style={{
        filter: earned ? '' : 'grayscale(100%)',
      }}
    >
      <div className="badgeLogoWrapper w-25">
        <AmbaImage alt={description} extraClass={`badgeLogo ${earned ? 'earned' : ''}`} imageSrc={image} isLink={false} />
      </div>
      <div className="badgeInfo w-75 pt-1 ms-1">
        <div className="badgeTitle f-raleway-regular f-12">
          <span>{name}</span>
        </div>
        {points > 0 && (
          <div className="badgePoints f-raleway-bold f-12" style={{ color: color }}>
            <span>{`${value} ` + t(`sidebar.tierMetric.${tier_stat_metric}`)}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default TierItem;
